import './AssessIntro.scss'
import React from 'react'
import { ASSESS_TYPE_LEADER } from '../constants'
import { assessStore } from '../stores'
import { Background, Button, IonIcon } from '../lib'
import imgSrc from '../assets/assess-bkg-02.png'

const AssessIntro = () => {
  return (
    <div className='AssessIntro'>
      <Background src={imgSrc} />
      <div className='AssessIntro_wrapper'>
        <h1>Ready to get started?</h1>
        {assessStore.type === ASSESS_TYPE_LEADER ? (
          <p>
            You can expect this questionnaire to take 10-15 minutes. Enter some basic metrics about your church and respond to a series of opinion questions. Then, invite the rest of your leadership team to submit their responses anonymously. Based on the aggregate data, you will receive an assessment of your church’s current life cycle stage, as well as a downloadable PDF report with our recommendations for your church’s priority next steps towards sustained health.
          </p>
        ) : (
          <p>
            You can expect this questionnaire to take 10-15 minutes. Respond to the series of opinion questions; then, based on the responses you submit, you will receive an assessment of your church’s current life cycle stage, as well as a downloadable PDF report with our recommendations for your church’s priority next steps towards sustained health.
          </p>
        )}
        <Button onClick={assessStore.start}>
          Begin Assessment <IonIcon icon='android-arrow-forward' />
        </Button>
      </div>
    </div>
  )
}

AssessIntro.displayName = 'AssessIntro'

export default AssessIntro



// WEBPACK FOOTER //
// ./src/assess/AssessIntro.js